import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EpicHeaderBannerText from '../../RifoDesign/EpicHeaderBannerText/epic.header.banner.text.vue';
import EpicGuideProcessBar from '../../RifoDesign/EpicGuideProcessBar/epic.guide.process.bar.vue';
import EpicStepDetail from '../../RifoDesign/EpicStepDetail/epic.step.detail.vue';
import { SubStep } from '../../RifoDesign/EpicStepDetail/epic.step.detail.component';
import EpicStandardLayout from '../../layout/EpicStandard/epic.standard.layout.vue';
import { CommonConfig } from '../../configs/config.common';

export interface Step {
    bgColor: string;
    graphic: string;
    reverse: boolean;
    stepName: string;
    detail: SubStep[];
}

@Component({
    components: {
        EpicHeaderBannerText,
        EpicGuideProcessBar,
        EpicStepDetail,
        'layout': EpicStandardLayout
    }
})
export default class EpicBuyerPage extends Vue {
    public configs = new CommonConfig();
    public stepsAll: Step[] = [];
    public points: ClientRect[] = [];
    public containerTop: number = 0;
    public leftBarHeight: number = 0;
    public stepsBar!: any[];
    public mobileBannerUri = `${this.configs.rifoDesignAssetsUrl}/epic-header/bg1.jpg`;
    public created() {
        this.stepsBar = [{
            title: 'Prepare for Buying',
            icon: `${this.configs.rifoDesignAssetsUrl}/epic-buyer-guide/step-icon1.png`,
            href: '/buyer-guide#step1'
        }, {
            title: 'Visit Properties',
            icon: `${this.configs.rifoDesignAssetsUrl}/epic-buyer-guide/step-icon2.png`,
            href: '/buyer-guide#step2'
        }, {
            title: 'Make An Offer',
            icon: `${this.configs.rifoDesignAssetsUrl}/epic-buyer-guide/step-icon3.png`,
            href: '/buyer-guide#step3'
        }, {
            title: 'Close The Deal',
            icon: `${this.configs.rifoDesignAssetsUrl}/epic-buyer-guide/step-icon4.png`,
            href: '/buyer-guide#step4'
        }];
        this.stepsAll = [{
            graphic: `${this.configs.rifoDesignAssetsUrl}/epic-buyer-guide/step1-graphic.png`,
            reverse: false,
            bgColor: '#ECF8FA',
            stepName: 'Prepare for buying',
            detail: [{
                name: 'Step 1: Know House Type',
                preText: 'There are four main house types in North America. Find which type is the best choice for you.',
                detailList: [{
                    icon: `${this.configs.rifoDesignAssetsUrl}/epic-buyer-guide/step1-1.png`,
                    title: 'Single-Family House',
                    paragraph: 'Single-family house is freestanding and used as a single dwelling unit.'
                }, {
                    icon: `${this.configs.rifoDesignAssetsUrl}/epic-buyer-guide/step1-2.png`,
                    title: 'Semi-Detached House',
                    paragraph: 'Semi-detached house is two distinct houses that shares one common wall with each other.'
                }, {
                    icon: `${this.configs.rifoDesignAssetsUrl}/epic-buyer-guide/step1-3.png`,
                    title: 'Townhouse',
                    paragraph: 'Townhouse is a number of common style house joined in a row by sharing common walls on both sides.'
                }, {
                    icon: `${this.configs.rifoDesignAssetsUrl}/epic-buyer-guide/step1-4.png`,
                    title: 'Condo',
                    paragraph: 'Condo, also called condominium, is a building complex containing a number of individually owned apartments with shared facilities'
                }],
                afterText: '',
                btnText: '',
                btnHref: '',
            }, {
                name: 'Step 2: Manage Your Finance',
                preText: `Buying a house is a big deal and a significant investment in your life,
                  you should prepare enough down payment, and necessary documents to apply for the mortgage.`,
                detailList: [],
                afterText: `During the house buying process, you also need to calculate land transfer tax, and monthly payment such as mortgage, property tax,
                 house insurance and maintenance fee.
                 Don’t let the debts go beyond your maximum affordable budgets.`,
                btnText: '',
                btnHref: ''
            }, {
                name: 'Step 3: Mortgage Pre-Approval',
                preText: `Before you buy a new house, it is important to understand pre-approval mortgage.
                 Ask a lender about pre-approval mortgage plan to know how much mortgage loan you can get base on your current income and credit history,
                 the pre-approval usually includes term, interest rate and mortgage amount.`,
                detailList: [],
                afterText: 'RIFO can help you to find the right mortgage broker to save as much as possible, thinking contact us for assistances',
                btnText: 'Contact Us',
                btnHref: '/contact-us'
            }]
        }, {
            graphic: `${this.configs.rifoDesignAssetsUrl}/epic-buyer-guide/step2-graphic.png`,
            reverse: true,
            bgColor: '#fff',
            stepName: 'Visit Properties',
            detail: [{
                name: 'Step 4: Contact a RIFO agent',
                preText: `RIFO is Grouped by thousands of experienced real agents, we promise to provide you excellent customer service to find your dream home.
                 Please feel free to contact a RIFO agent and tell agent your requirements for your home,  he or she knows what kind of house suits you best.  `,
                detailList: [],
                afterText: '',
                btnText: '',
                btnHref: '',
            }, {
                name: 'Step 5: Visit Open Houses',
                preText: `Once you have found a RIFO agent,  he or she knows your local housing market very well,
                  and will be happy to notice you the open house information that interests you.`,
                detailList: [],
                afterText: '',
                btnText: '',
                btnHref: ''
            }, {
                name: 'Step 6: Check House Information on RIFO App ',
                preText: `RIFO has built the best house-searching system on where you can explore  massive publicly-available house listings,
                 You can view, save or share house information by using RIFO app, we wish to help you find the right home for the right price,
                  you can download it for free here.`,
                detailList: [],
                afterText: '',
                btnText: 'Download App',
                btnHref: '/download-app'
            }]
        }, {
            graphic: `${this.configs.rifoDesignAssetsUrl}/epic-buyer-guide/step3-graphic.png`,
            reverse: false,
            bgColor: '#ECF8FA',
            stepName: 'Make An Offer',
            detail: [{
                name: 'Step 7: Provide Your Offer',
                preText: `If you find a perfect house and want to make it as your own, you are reaching the most significant step during the whole buying process.
                <br/><br/>A listing house has its own asking price,  your RIFO agent will  advice you how to give competing price and conditions to maximize your interests.`,
                detailList: [{
                    icon: `${this.configs.rifoDesignAssetsUrl}/epic-buyer-guide/step3-1.png`,
                    title: 'Accepted by Seller',
                    paragraph: 'If your offer has been accepted by the seller. Congrats, the house is almost yours.'
                }, {
                    icon: `${this.configs.rifoDesignAssetsUrl}/epic-buyer-guide/step3-2.png`,
                    title: '“Sign Back” An Offer',
                    paragraph: `If your offer is rejected but not completely by the seller,
                      you still have change to own the house.
                      Your RIFO agent will use art of negotiation to  sign back the offer by making rational changes that satisfy both seller and buyer’s sides. `
                }, {
                    icon: `${this.configs.rifoDesignAssetsUrl}/epic-buyer-guide/step3-2.png`,
                    title: 'Hire A Home Inspector',
                    paragraph: `If your offer includes home inspection and accepted by the seller,
                     you can hire a professional home inspector in response to scrutinize every last details inside and outside your ideal home,
                      That way can save you from unpleasant costs before you close the deal. RIFO also provide home inspection services, please contact us for details.`
                }],
                afterText: '',
                btnText: 'Contact Us',
                btnHref: '/contact-us',
            }]
        }, {
            graphic: `${this.configs.rifoDesignAssetsUrl}/epic-buyer-guide/step4-graphic.png`,
            reverse: true,
            bgColor: '#fff',
            stepName: 'Close The Deal',
            detail: [{
                name: 'Step 8: Find A Trusted Lawyer',
                preText: `Finding a trusted lawyer in RIFO team to handle all necessary legal documents related to the buying process.
                 It is essential to let the lawyer review important terms in the offer before you sign your signature. `,
                detailList: [],
                afterText: '',
                btnText: '',
                btnHref: '',
            }, {
                name: 'Step 9:  Close the deal',
                preText: `When both buyer and seller agree with an offer,  the buying process is approaching the final step,
                 RIFO agent and lawyer will help you to do most of closing work, please prepare all required documents for closing the deal. `,
                detailList: [],
                afterText: '',
                btnText: '',
                btnHref: '',
            }, {
                name: 'Step 10: Move into Your New Home And More',
                preText: `The seller will leave the key to you on the closing day,  that means at this point you are the true owner of your new home.
                 You can find the moving services from RIFO app,
                  and many other services such as house cleaning, decoration, roofing and many other services. Download now to make your life easier.
                `,
                detailList: [],
                afterText: '',
                btnText: 'Download App',
                btnHref: '/download-app',
            }]
        }];

    }
    public mounted() {
        const containerEl = (this.$refs[`container`] as any);
        this.containerTop = containerEl.getBoundingClientRect().top;
        for (let i = 0; i < this.stepsAll.length; i++) {
            const el = (this.$refs[`step_${i}`] as any)[0].$el;
            this.points.push(el.getBoundingClientRect());
        }
        this.leftBarHeight =  this.points[this.stepsAll.length - 1].top - this.points[0].top;
    }
}
